import { useSelector } from "react-redux";
import { RootState } from "State/store";

export const useCartProductList = () =>
  useSelector((state: RootState) => state.cart.cartProductList);
